var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-center border-bottom pb-2"},[_c('h5',[_vm._t("titulo")],2)])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"text-center"},[_c('h4',[_vm._t("conteudo")],2)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._t("legenda")],2)])])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ff1588","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BoxCard01.vue
// module id = 704
// module chunks = 30